import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import CampaignService from "../../../services/OrderingServices/CampaignService";
import AdvertisersService from "../../../services/OrderingServices/AdvertisersService";
import CloudRestroUsers from "../../../services/DatabaseService/CloudRestroUsers";

const FilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
  setCurrentPage,
}) => {
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [advertiserOptions, setAdvertiserOptions] = useState([]);
  const [loadingCampaigns, setLoadingCampaigns] = useState(false);
  const [loadingAdvertisers, setLoadingAdvertisers] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [loadingOrgs, setLoadingOrgs] = useState(false);
  // Fetch campaigns and advertisers on component mount
  useEffect(() => {
    fetchCampaigns();
    fetchAdvertisers();
  }, []);

  const fetchCampaigns = async () => {
    try {
      setLoadingCampaigns(true);
      const response = await CampaignService.campaignsList({
        pageNumber: 1,
        pageSize: 1000, // Fetch all campaigns
      });

      console.log("🚀 ~ campaigns response:", response);

      // Handle both array directly and object with data property
      const campaignsList = Array.isArray(response)
        ? response
        : response?.data || [];

      if (campaignsList && campaignsList.length > 0) {
        const options = campaignsList.map((campaign) => ({
          value: campaign.id,
          label: campaign.name,
        }));
        setCampaignOptions(options);
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
    } finally {
      setLoadingCampaigns(false);
    }
  };

  const fetchOrganizationsWithDevices = async () => {
    try {
      setLoadingOrgs(true);

      const response = await CloudRestroUsers.getWithDevices({
        onlyWithDevices: true,
      });

      console.log("🚀 Organizations with devices:", response);

      if (Array.isArray(response) && response.length > 0) {
        // Filter only orgs that actually have devices
        const filtered = response.filter(
          (org) => org.devices && org.devices.length > 0,
        );

        const options = filtered.map((org) => ({
          value: org.organizationId,
          label: `${org.name} (${org.orgCode})`,
        }));

        setOrgOptions(options);
      }
    } catch (error) {
      console.error("Error fetching organizations:", error);
    } finally {
      setLoadingOrgs(false);
    }
  };

  useEffect(() => {
    fetchOrganizationsWithDevices();
  }, []);

  const fetchAdvertisers = async () => {
    try {
      setLoadingAdvertisers(true);
      const response = await AdvertisersService.advertisersList({
        page: 1,
        pageSize: 1000, // Fetch all advertisers
      });

      console.log("🚀 ~ advertisers response:", response);

      // Handle both array directly and object with data property
      const advertisersList = Array.isArray(response)
        ? response
        : response?.data || [];

      if (advertisersList && advertisersList.length > 0) {
        const options = advertisersList.map((advertiser) => ({
          value: advertiser.id,
          label: advertiser.advertiserName,
        }));
        setAdvertiserOptions(options);
      }
    } catch (error) {
      console.error("Error fetching advertisers:", error);
    } finally {
      setLoadingAdvertisers(false);
    }
  };

  const handleCampaignChange = (selectedOption) => {
    handleFilterChange(
      "campaignId",
      selectedOption ? selectedOption.value : "",
    );
  };

  const handleAdvertiserChange = (selectedOption) => {
    handleFilterChange(
      "advertiserId",
      selectedOption ? selectedOption.value : "",
    );
  };

  return (
    <>
      <Row className="">
        <Col lg="12">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-light">
              <Row className="align-items-center justify-content-between w-100">
                <Col md="auto">
                  <h5 className="mb-0 d-flex align-items-center gap-2">
                    <i className="bx bx-filter-alt"></i> Search & Filter
                  </h5>
                </Col>

                <Col md="auto" className="d-flex gap-2">
                  {/* <Button
                  color="primary"
                  size="sm"
                  onClick={() => setCurrentPage(1)}
                >
                  <i className="bx bx-search me-2"></i>Apply Filters
                </Button> */}
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={handleClearFilters}
                  >
                    <i className="bx bx-reset me-2"></i>Clear All
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <Row className="g-3">
                <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Organization
                    </Label>
                    <Select
                      options={orgOptions}
                      value={
                        filters.organizationId
                          ? orgOptions.find(
                              (option) =>
                                option.value === filters.organizationId,
                            )
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleFilterChange(
                          "organizationId",
                          selectedOption ? selectedOption.value : "",
                        )
                      }
                      placeholder="Choose organization..."
                      isClearable
                      isLoading={loadingOrgs}
                      classNamePrefix="react-select"
                    />
                  </FormGroup>
                </Col>
                {/* Advertiser Name Dropdown */}
                {/* <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Advertiser
                    </Label>
                    <Select
                      options={advertiserOptions}
                      value={advertiserOptions.find(
                        (option) => option.value === filters.advertiserId,
                      )}
                      onChange={handleAdvertiserChange}
                      placeholder="Choose an advertiser..."
                      isClearable
                      isLoading={loadingAdvertisers}
                      classNamePrefix="react-select"
                    />
                  </FormGroup>
                </Col> */}

                {/* Campaign Name Dropdown */}
                {/* <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Campaign
                    </Label>
                    <Select
                      options={campaignOptions}
                      value={campaignOptions.find(
                        (option) => option.value === filters.campaignId,
                      )}
                      onChange={handleCampaignChange}
                      placeholder="Choose a campaign..."
                      isClearable
                      isLoading={loadingCampaigns}
                      classNamePrefix="react-select"
                    />
                  </FormGroup>
                </Col> */}

                {/* MAC ID */}
                {/* <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold">MAC ID</Label>
                    <Input
                      type="text"
                      placeholder="MAC ID"
                      value={filters.macId}
                      onChange={(e) =>
                        handleFilterChange("macId", e.target.value)
                      }
                      bsSize="md"
                    />
                  </FormGroup>
                </Col> */}

                {/* Screen Name */}
                {/* <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold">Screen Name</Label>
                    <Input
                      type="text"
                      placeholder="Screen Name"
                      value={filters.screenName || ""}
                      onChange={(e) =>
                        handleFilterChange("screenName", e.target.value)
                      }
                      bsSize="md"
                    />
                  </FormGroup>
                </Col> */}

                <Col md="3">
                  <FormGroup className="mb-0">
                    <Label className="small fw-bold d-block mb-2">
                      Date Range
                    </Label>

                    <div style={{ position: "relative", zIndex: 10 }}>
                      <Flatpickr
                        value={[filters.fromDate, filters.toDate]}
                        onChange={(dates) => {
                          if (dates.length === 2) {
                            handleFilterChange("fromDate", dates[0]);
                            handleFilterChange("toDate", dates[1]);
                          }
                        }}
                        options={{
                          mode: "range",
                          enableTime: true,
                          dateFormat: "Y-m-d H:i",
                          closeOnSelect: false,
                        }}
                        className="form-control form-control-md w-100"
                        placeholder="Start - End Date"
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default FilterCard;
